import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaskPriorityHigh = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#515d71",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3 11C3 10.4477 3.44772 10 4 10C4.55228 10 5 10.4477 5 11V13C5 13.5523 4.55228 14 4 14C3.44772 14 3 13.5523 3 13V11Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8V13C9 13.5523 8.55228 14 8 14C7.44772 14 7 13.5523 7 13V8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 4,
			width: 2,
			height: 10,
			rx: 1,
			fill: "currentColor"
		})
	]
});
export default SvgTaskPriorityHigh;
